module.exports = __webpack_public_path__ + "img/travel3.d15cbf67.png";